<table class="table table-hover table-striped">
  <thead>
    <tr>
      <th
        (click)="sortBy('testname')"
        role="button"
        scope="col"
      >
        {{ 'label.name' | translate }}
        <span *ngIf="sortColumn === 'testname'">
          <i class="bi" [class]="sortDirection === 'asc' ? 'bi-caret-up-fill' : 'bi-caret-down-fill'"></i>
        </span>
      </th>
    </tr>
  </thead>
  <tbody>
    <tr
      *ngFor="let row of items"
      [routerLink]="[row.id]"
      class="clickable cursor-pointer"
    >
      <td>{{ row.testname }}</td>
    </tr>
  </tbody>
</table>
